{
  "title": "Maintenance contracts",
  "retry": "Try again",
  "conflictLoaded": "This contract was changed in the meantime. The latest is loaded now: check it and try again.",
  "status": {
    "DRAFT": "Draft",
    "ACTIVE": "Active",
    "EXPIRED": "Expired",
    "TERMINATED": "Terminated",
    "CANCELLED": "Cancelled"
  },
  "actions": {
    "new": "New contract",
    "activate": "Activate",
    "renew": "Renew",
    "edit": "Edit",
    "print": "Print the contract",
    "terminate": "Terminate",
    "cancelDraft": "Cancel draft",
    "generate": "Make planned visits now"
  },
  "punch": {
    "state": {
      "DONE": "done",
      "PARTIAL": "partly done",
      "PLANNED": "planned",
      "LATE": "late",
      "MISSED": "missed",
      "SKIPPED": "skipped",
      "NONE": "nothing due"
    },
    "underway": "under way",
    "quarter": "Q{{n}}",
    "half": "H{{n}}",
    "week": "W{{n}}",
    "quarterLong": {
      "1": "Q1 {{year}}",
      "2": "Q2 {{year}}",
      "3": "Q3 {{year}}",
      "4": "Q4 {{year}}"
    },
    "halfLong": {
      "1": "H1 {{year}}",
      "2": "H2 {{year}}"
    },
    "weekLong": "Week {{n}}, {{year}}",
    "current": "current period",
    "visitsDone_one": "{{done}} of {{due}} visit done",
    "visitsDone_other": "{{done}} of {{due}} visits done",
    "empty": "No periods yet."
  },
  "interval": {
    "WEEK_one": "Every week",
    "WEEK_other": "Every {{n}} weeks",
    "MONTH_one": "Every month",
    "MONTH_other": "Every {{n}} months",
    "YEAR_one": "Every year",
    "YEAR_other": "Every {{n}} years"
  },
  "period": {
    "starts": "Starts {{date}}",
    "startsIn_one": "Starts in {{n}} day",
    "startsIn_other": "Starts in {{n}} days",
    "endsIn_one": "Ends in {{n}} day",
    "endsIn_other": "Ends in {{n}} days",
    "endsToday": "Ends today",
    "endedAgo_one": "Ended {{n}} day ago",
    "endedAgo_other": "Ended {{n}} days ago",
    "day": "Day {{day}} of {{total}}"
  },
  "renewal": {
    "renewedBy": "Renewed by",
    "renews": "Renews"
  },
  "compliance": {
    "none": "No planned visits due yet",
    "figure": "{{done}} of {{due}} planned visits done · {{percent}}%",
    "figureSkipped_one": "{{done}} of {{due}} planned visits done · {{percent}}% ({{n}} skipped)",
    "figureSkipped_other": "{{done}} of {{due}} planned visits done · {{percent}}% ({{n}} skipped)"
  },
  "schedule": {
    "MONTHLY": "Monthly",
    "QUARTERLY": "Quarterly",
    "HALF_YEARLY": "Half-yearly",
    "YEARLY": "Yearly",
    "UPFRONT": "Upfront (one instalment)",
    "CUSTOM": "Custom (entered by hand)"
  },
  "scheduleWord": {
    "MONTHLY": "monthly",
    "QUARTERLY": "quarterly",
    "HALF_YEARLY": "half-yearly",
    "YEARLY": "yearly",
    "UPFRONT": "upfront",
    "CUSTOM": "custom"
  },
  "timing": {
    "ADVANCE": "In advance",
    "ARREARS": "In arrears"
  },
  "timingBody": {
    "ADVANCE": "Each instalment is billed on the first day of its period.",
    "ARREARS": "Each instalment is billed on the last day of its period."
  },
  "timingShort": {
    "ADVANCE": "in advance",
    "ARREARS": "in arrears"
  },
  "terms": {
    "title": "Terms",
    "labour": "Labour",
    "parts": "Parts",
    "consumables": "Consumables",
    "callOuts": "Call-outs",
    "response": "Response time",
    "noResponse": "None promised",
    "special": "Special terms",
    "notes": "Notes",
    "billingTitle": "Price and billing",
    "value": "Value (before VAT)",
    "taxRate": "VAT",
    "defaultTax": "The company's default sales rate",
    "schedule": "Billing",
    "timing": "Billed",
    "callOutsUsed": "Call-outs {{used}} of {{allowance}} used this contract year",
    "callOutsUsedUnlimited_one": "{{n}} call-out this contract year",
    "callOutsUsedUnlimited_other": "{{n}} call-outs this contract year",
    "words": {
      "labour": {
        "INCLUDED": "Labour included",
        "EXCLUDED": "Labour billed"
      },
      "parts": {
        "INCLUDED": "Parts included",
        "EXCLUDED": "Parts billed",
        "CAPPED": "Parts included up to a cap"
      },
      "partsCap": {
        "PER_JOB": "Parts included up to {{cap}} a job",
        "PER_YEAR": "Parts included up to {{cap}} a contract year"
      },
      "partsCapped": "Parts included up to a cap",
      "consumables": {
        "INCLUDED": "Consumables included",
        "EXCLUDED": "Consumables billed"
      },
      "callOutsAllowance_one": "{{n}} call-out a year included",
      "callOutsAllowance_other": "{{n}} call-outs a year included",
      "callOutsUnlimited": "Call-outs included",
      "callOutsExcluded": "Call-outs billed",
      "response_one": "Response within {{n}} hour",
      "response_other": "Response within {{n}} hours"
    }
  },
  "reason": {
    "LABOUR_INCLUDED": "labour included",
    "LABOUR_EXCLUDED": "labour is billed under this contract",
    "CALL_OUTS_EXCLUDED": "call-outs are billed under this contract",
    "CALL_OUT_OVER_ALLOWANCE": "over the year's call-out allowance",
    "PARTS_INCLUDED": "parts included",
    "PARTS_EXCLUDED": "parts are billed under this contract",
    "PARTS_WITHIN_CAP": "within the parts cap",
    "PARTS_OVER_CAP": "over the parts cap",
    "CONSUMABLES_INCLUDED": "consumables included",
    "CONSUMABLES_EXCLUDED": "consumables are billed under this contract",
    "SET_BY_HAND": "set by hand"
  },
  "checkOutcome": {
    "DONE": "Done",
    "ISSUE": "Issue found",
    "NO_ACCESS": "No access",
    "SKIPPED": "Skipped"
  },
  "checkResult": {
    "done": "done",
    "notDone": "not done"
  },
  "errors": {
    "CONTRACTS_OFF": "Maintenance contracts are turned off for your company.",
    "CONTRACT_NOT_ACTIVE": "This contract isn't active today, so it can't take the job. Choose another contract or bill the job.",
    "CONTRACT_NOT_FOR_SITE": "This contract doesn't cover the job's site.",
    "CONTRACT_NOT_DRAFT": "Only a draft can be activated or cancelled.",
    "CONTRACT_NOT_ACTIVE_STATE": "Only an active contract can be terminated.",
    "CONTRACT_FINAL": "This contract has ended and no longer changes.",
    "CONTRACT_INCOMPLETE": "The contract needs at least one site, and coverage that reaches an asset, before it can be activated.",
    "CONTRACT_PENDING_APPROVAL": "The contract is waiting for approval and can't change until it is decided.",
    "ALREADY_RENEWED": "This contract has been renewed already.",
    "NOT_RENEWABLE": "A terminated or cancelled contract isn't renewed.",
    "RENEWAL_OVERLAP": "A renewal starts after the last day of the contract it renews: the two can't cover the same day.",
    "SITE_UNDER_CONTRACT": "An active maintenance contract covers this site: terminate it, or take the site off it, first.",
    "SITE_NOT_OF_CUSTOMER": "A chosen site isn't this customer's, or it is archived.",
    "ASSET_NOT_AT_SITE": "A picked asset isn't at one of the contract's sites.",
    "SITE_HAS_OPEN_JOBS": "A site can't leave the contract while it has open planned jobs.",
    "OCCURRENCE_STARTED": "This planned visit has started and can't be skipped.",
    "OCCURRENCE_SKIPPED": "This planned visit was skipped already.",
    "BILLING_ITEM_INVOICED": "This instalment is invoiced and no longer changes.",
    "BILLING_ITEM_NOT_READY": "This instalment isn't ready to invoice yet.",
    "BILLING_ITEM_CANCELLED": "This instalment is cancelled.",
    "SALES_MODULE_OFF": "Sales is turned off for your company, so instalments can't be invoiced.",
    "ASSET_CHECKS_OFF": "Asset checklists are turned off in Settings › Service.",
    "ASSET_NOT_ON_JOB": "This asset isn't on the job.",
    "ASSET_NOT_IN_VISIT_SCOPE": "This asset isn't in the places this visit covers.",
    "CHECKS_INCOMPLETE": "Some assets of this planned job aren't checked yet.",
    "PLACE_NOT_AT_SITE": "A chosen place isn't at the job's site."
  },
  "register": {
    "title": "Maintenance contracts",
    "count_one": "{{n}} contract",
    "count_other": "{{n}} contracts",
    "views": "Contract views",
    "view": {
      "active": "Active",
      "expiring": "Expiring",
      "draft": "Drafts",
      "ended": "Ended",
      "all": "All"
    },
    "searchPlaceholder": "Search number, title or customer…",
    "searchLabel": "Search contracts",
    "clearSearch": "Clear search",
    "clearFilters": "Clear filters",
    "filterCustomer": "Customer",
    "anyCustomer": "Any customer",
    "forCustomer": "Contracts of {{name}}",
    "tableLabel": "Maintenance contracts",
    "untitled": "No title",
    "moreSites_one": "and {{n}} more site",
    "moreSites_other": "and {{n}} more sites",
    "recentLabel": "{{number}}: the last periods of its plans",
    "recentPlanLabel": "{{number}}: {{plan}}, the last periods",
    "pendingApproval": "Awaiting approval",
    "nextDue": "Next visit {{date}}",
    "overdueSince": "Overdue since {{date}}",
    "empty": {
      "title": "No contracts yet.",
      "body": "Add the first contract: the customer's sites, what is covered and on what terms.",
      "readOnly": "Contracts appear here once someone adds them.",
      "filteredTitle": "No contracts match.",
      "filteredBody": "Try other words, or clear the filters.",
      "view": {
        "active": "No active contracts.",
        "expiring": "No contract ends in the next 60 days.",
        "draft": "No drafts.",
        "ended": "No contracts have ended.",
        "all": "No contracts."
      }
    }
  },
  "columns": {
    "number": "Number",
    "customer": "Customer",
    "title": "Title",
    "sites": "Sites",
    "period": "Period",
    "value": "Value",
    "compliance": "Compliance",
    "nextDue": "Next planned visit",
    "status": "Status"
  },
  "page": {
    "title": "Maintenance contract",
    "backToRegister": "Back to the contracts",
    "pendingApproval": "Awaiting approval",
    "pendingApprovalReason": "It is waiting for approval.",
    "pendingApprovalTitle": "Awaiting approval",
    "pendingApprovalBody": "The contract was sent for approval. It can't change until it is approved or returned.",
    "terminatedTitle": "Terminated from {{date}} by {{name}}",
    "cancelledTitle": "Cancelled on {{date}}",
    "expiredTitle": "Expired on {{date}}",
    "expiredRenew": "It no longer covers jobs. Renew it to keep the customer covered.",
    "expiredBody": "It no longer covers jobs.",
    "draftNoSites": "Choose the customer's sites before activating: edit the draft.",
    "soldBy": "Sold by {{name}}"
  },
  "figures": {
    "label": "Contract figures",
    "value": "Value",
    "valueSub": "before VAT",
    "starts": "Starts",
    "startsSub": "a draft until it is activated",
    "invoiced": "Invoiced",
    "invoicedSub": "with VAT",
    "collected": "Collected",
    "balance": "Balance",
    "visits": "Planned visits",
    "ofCount": "{{done}} of {{due}}",
    "compliance": "{{percent}}% compliance",
    "complianceSkipped_one": "{{percent}}% compliance ({{n}} skipped)",
    "complianceSkipped_other": "{{percent}}% compliance ({{n}} skipped)",
    "issues": "Open issues",
    "issuesSub": "assets with an issue not yet fixed",
    "callOuts": "Call-outs",
    "callOutsSub": "this contract year, from {{date}}",
    "callOutsUnlimited": "this contract year"
  },
  "tabs": {
    "label": "Contract sections",
    "coverage": "Coverage",
    "plans": "Plans",
    "visits": "Visits",
    "terms": "Terms",
    "jobs": "Jobs",
    "files": "Files",
    "activity": "Activity",
    "billing": "Billing",
    "tasks": "Tasks"
  },
  "coverage": {
    "words": {
      "ALL": "Everything at these sites",
      "TYPES": "{{types}} at these sites",
      "ASSETS_one": "A picked list of {{n}} asset",
      "ASSETS_other": "A picked list of {{n}} assets"
    },
    "coveredNow_one": "{{n}} asset covered now",
    "coveredNow_other": "{{n}} assets covered now",
    "coveredEnded_one": "Covered {{n}} asset",
    "coveredEnded_other": "Covered {{n}} assets",
    "sites": "Sites",
    "site": "Site",
    "covered": "Covered",
    "ofAssets": "{{covered}} of {{total}}",
    "ofAssetsCount_one": "{{covered}} of {{n}} asset",
    "ofAssetsCount_other": "{{covered}} of {{n}} assets",
    "archived": "Archived",
    "noSites": "No sites yet.",
    "noSitesBody": "Edit the draft to choose the customer's sites.",
    "assetsTitle": "Covered assets",
    "filterSite": "Site",
    "allSites": "All sites",
    "search": "Search tag, place or type…",
    "clearSearch": "Clear search",
    "noAssets": "No assets covered yet.",
    "noAssetsBody": "Assets added at the contract's sites are covered as they are added.",
    "noMatches": "No covered asset matches.",
    "neverChecked": "Not checked yet",
    "columns": {
      "asset": "Asset",
      "type": "Type",
      "place": "Place",
      "site": "Site",
      "warranty": "Warranty until",
      "lastCheck": "Last check"
    }
  },
  "plans": {
    "title": "Plans",
    "tagTitle": "Maintenance tag",
    "stripLabel": "{{name}}: maintenance tag",
    "noneShort": "No plans yet: planned visits start once a plan is added.",
    "emptyTitle": "No plans yet.",
    "emptyBody": "Add a plan: what is serviced, how often and with which checklist.",
    "emptyReadOnly": "Plans make the planned visits; none is set up yet.",
    "addTitle": "Add a plan",
    "add": "Add plan",
    "save": "Save plan",
    "edit": "Edit",
    "editTitle": "Edit {{name}}",
    "drawerBody": "Planned jobs already made keep their dates; the next ones follow this plan.",
    "pause": "Pause",
    "resume": "Resume",
    "paused": "Paused",
    "from": "from {{date}}",
    "assetCount_one": "{{n}} asset",
    "assetCount_other": "{{n}} assets",
    "checklistItems_one": "{{n}} item: {{items}}",
    "checklistItems_other": "{{n}} items: {{items}}",
    "minutes": "{{n}} min per asset",
    "nextDue": "Next due",
    "noMoreDue": "No more visits in this contract",
    "overdueSince": "Overdue since {{date}}",
    "lastErrorTitle": "The planner couldn't make this plan's jobs",
    "preview": "First due dates:",
    "previewNone": "no due date within the contract",
    "scope": {
      "ALL": "Every covered asset",
      "ALLBody": "Each asset the contract covers is serviced.",
      "TYPES": "Asset types",
      "TYPESBody": "Only the covered assets of the chosen types."
    },
    "checklist": {
      "TYPE": "Each asset type's own checklist",
      "TYPEBody": "As set up in Settings › Asset types.",
      "CUSTOM": "A checklist for this plan",
      "CUSTOMBody": "One list for every asset the plan covers."
    },
    "unit": {
      "WEEK": "Weeks",
      "MONTH": "Months",
      "YEAR": "Years"
    },
    "fields": {
      "name": "Name",
      "namePlaceholder": "Quarterly full service",
      "nameAr": "Name in Arabic",
      "scope": "What it covers",
      "types": "Asset types",
      "typesPlaceholder": "Choose the asset types",
      "typesSearch": "Search asset types…",
      "typesEmpty": "No asset type matches.",
      "typesClear": "Clear",
      "typesCount_one": "{{n}} type",
      "typesCount_other": "{{n}} types",
      "every": "Every",
      "unit": "Unit",
      "firstDue": "First due",
      "firstDueHint": "Within the contract",
      "checklist": "Checklist",
      "minutes": "Minutes per asset",
      "minutesHint": "For planning the visits; optional"
    },
    "check": {
      "row": "Checklist item {{n}}",
      "en": "Item",
      "ar": "Item in Arabic",
      "key": "Key",
      "kind": "Kind",
      "kinds": {
        "check": "Check (done or not)",
        "reading": "Reading (a number)"
      },
      "unit": "Unit",
      "up": "Move {{name}} up",
      "down": "Move {{name}} down",
      "remove": "Remove {{name}}",
      "add": "Add item"
    },
    "errors": {
      "name": "Name the plan.",
      "types": "Choose the asset types the plan covers.",
      "interval": "Enter a number from 1 to 60.",
      "firstDue": "Choose a first due date within the contract.",
      "checklist": "Add the checklist items, each with its own key.",
      "minutes": "Enter minutes from 1 to 600, or leave it empty.",
      "key": "Lower-case letters, digits and _ only, starting with a letter.",
      "label": "Name the item in English and Arabic.",
      "row": "Check this item."
    },
    "toast": {
      "added": "Plan {{name}} added",
      "saved": "Plan {{name}} saved",
      "paused": "Plan {{name}} paused",
      "resumed": "Plan {{name}} resumed"
    }
  },
  "jobs": {
    "title": "Jobs under this contract",
    "origin": "Kind of job",
    "anyOrigin": "Call-outs and planned visits",
    "origins": {
      "REQUEST": "Call-outs",
      "PLANNED": "Planned visits"
    },
    "new": "New job",
    "empty": "No jobs under this contract yet.",
    "emptyBody": "Call-outs at its sites and its planned visits are listed here.",
    "noneOfOrigin": "No jobs of this kind."
  },
  "visits": {
    "title": "Planned visits",
    "columns": {
      "period": "Period",
      "plan": "Plan",
      "site": "Site",
      "due": "Due",
      "status": "Status",
      "job": "Job",
      "next": "Next visit"
    },
    "status": {
      "PLANNED": "Planned",
      "SCHEDULED": "Scheduled",
      "IN_PROGRESS": "In progress",
      "DONE": "Done",
      "LATE": "Late",
      "MISSED": "Missed",
      "SKIPPED": "Skipped"
    },
    "checked": "{{checked}} / {{total}} checked",
    "doneOn": "Done {{date}}",
    "notScheduled": "Not scheduled",
    "overdue": "Overdue",
    "filterPlan": "Plan",
    "filterSite": "Site",
    "filterStatus": "Status",
    "anyPlan": "Any plan",
    "anySite": "Any site",
    "anyStatus": "Any status",
    "skip": "Skip visit",
    "skipStarted": "This visit has started: a technician attended it, so it can't be skipped.",
    "actionsFor": "Actions for {{period}} at {{site}}",
    "noMatches": "No planned visits match.",
    "clearFilters": "Clear filters",
    "empty": "No planned visits yet.",
    "emptyNoPlans": "Add a plan on the Plans tab: its visits are made before each due date.",
    "emptyDraft": "Planned visits are made once the contract is activated.",
    "emptyBody": "The planner makes each visit shortly before it is due.",
    "skipDialog": {
      "title": "Skip {{period}} at {{site}}",
      "body": "Its planned job {{job}} is cancelled, and the period is left out of the compliance figure.",
      "reason": "Reason",
      "reasonPlaceholder": "Tenant away for the summer",
      "reasonRequired": "Give a reason.",
      "confirm": "Skip visit",
      "keep": "Keep the visit"
    },
    "toast": {
      "skipped": "Visit of {{period}} at {{site}} skipped"
    }
  },
  "generate": {
    "running": "Making the planned visits…",
    "made_one": "{{n}} planned visit made",
    "made_other": "{{n}} planned visits made",
    "window": "Each due in the next {{days}} days.",
    "none": "No new planned visits: every period is made already",
    "nothingDue": "No planned visits are due yet: each is made shortly before its due date",
    "nextMake": "The next ones are made on {{date}}.",
    "noneMade": "No planned visits made",
    "failed_one": "{{n}} plan couldn't make its visits: {{plans}}",
    "failed_other": "{{n}} plans couldn't make their visits: {{plans}}"
  },
  "activate": {
    "title": "Activate {{number}}?",
    "covers_one": "It covers jobs at its {{n}} site from {{start}} to {{end}}.",
    "covers_other": "It covers jobs at its {{n}} sites from {{start}} to {{end}}.",
    "plans_one": "Its plan starts making planned jobs, {{days}} days before each due date.",
    "plans_other": "Its {{n}} plans start making planned jobs, {{days}} days before each due date.",
    "noPlans": "It has no plans yet: add them on the Plans tab to have planned visits.",
    "instalments_one": "{{n}} instalment is made from the schedule ({{schedule}}).",
    "instalments_other": "{{n}} instalments are made from the schedule ({{schedule}}).",
    "customBilling": "The schedule is custom: enter the instalments on the contract.",
    "frozen": "The customer and the start date can no longer change.",
    "confirm": "Activate contract",
    "confirmApproval": "Send for approval",
    "keep": "Keep as a draft"
  },
  "renew": {
    "title": "Renew {{number}}",
    "body": "A new draft starts the day after this contract ends, with the same sites, coverage, terms, plans and billing.",
    "start": "Starts",
    "end": "Ends",
    "percent": "Price change",
    "percentHint": "5 raises the price by 5%; -2.5 lowers it.",
    "valuePreview": "Value {{from}} becomes {{to}}",
    "valueUnknown": "Enter the change as a percentage, e.g. 5 or -2.5.",
    "confirm": "Make the renewal",
    "errors": {
      "end": "The end is before the start.",
      "percent": "Enter a percentage, e.g. 5 or -2.5 (above -100)."
    }
  },
  "terminate": {
    "title": "Terminate {{number}}",
    "body": "The contract stops covering jobs from the date you choose. This can't be undone.",
    "date": "Effective date",
    "dateHint": "Within the contract's period",
    "previewTitle": "What terminating on {{date}} cancels",
    "previewFailed": "Couldn't list what would be cancelled.",
    "nothing": "Nothing planned or billed after this date: nothing is cancelled.",
    "jobs_one": "{{n}} planned job with no visit yet will be cancelled:",
    "jobs_other": "{{n}} planned jobs with no visit yet will be cancelled:",
    "instalments_one": "{{n}} instalment not invoiced will be cancelled:",
    "instalments_other": "{{n}} instalments not invoiced will be cancelled:",
    "due": "due {{date}}",
    "reason": "Reason",
    "confirm": "Terminate contract",
    "keep": "Keep the contract",
    "errors": {
      "date": "Choose a date within the contract's period.",
      "reason": "Give a reason."
    }
  },
  "cancel": {
    "title": "Cancel draft {{number}}?",
    "body": "The draft for {{customer}} is kept as cancelled and its number stays used.",
    "withdraws": "It is waiting for approval: cancelling it withdraws the request, and the approvers' tasks close.",
    "reason": "Reason",
    "confirm": "Cancel draft",
    "keep": "Keep draft",
    "errors": {
      "reason": "Give a reason."
    }
  },
  "toast": {
    "created": "Contract {{number}} saved as a draft",
    "createdActive": "Contract {{number}} is active",
    "saved": "Contract {{number}} saved",
    "activated": "Contract {{number}} is active",
    "activatedFrom": "Contract {{number}} is active from {{date}}",
    "sentForApproval": "Contract {{number}} was sent for approval",
    "savedNotActivated": "{{number}} is saved as a draft, not activated: {{reason}}",
    "renewed": "Renewal {{number}} drafted",
    "terminated": "Contract {{number}} terminated",
    "cancelled": "Draft {{number}} cancelled"
  },
  "form": {
    "newTitle": "New maintenance contract",
    "newMeta": "Saved as a draft: it covers jobs once it is activated.",
    "editTitle": "Edit {{number}}",
    "editMeta": {
      "DRAFT": "A draft: everything can change.",
      "ACTIVE": "Active: the customer and the start date stay; the end only moves later; each change is kept in its history."
    },
    "notEditable": "This contract is {{status}} and no longer changes.",
    "waitingTitle": "Waiting for approval",
    "waitingBody": "This draft was sent for approval, so it can't change until the request is decided. To change it now, withdraw the request on the contract's page.",
    "backToContract": "Back to {{number}}",
    "stale": {
      "title": "This contract was changed since you opened it",
      "kept": "What you typed here is kept, not saved. Load the latest to see the changes, then make yours again.",
      "notSaved": "Your changes weren't saved; they are still here. Load the latest to see what changed, then make yours again.",
      "clean": "Load the latest to edit it as it is now.",
      "locked": "It can no longer be edited here.",
      "load": "Load latest",
      "loadDiscard": "Load latest (discards your changes)",
      "loadFailed": "Couldn't load the latest. Try again."
    },
    "sections": {
      "customer": "Customer and sites",
      "coverage": "Coverage",
      "terms": "Terms",
      "plans": "Plans",
      "price": "Price and billing",
      "review": "What the customer gets"
    },
    "customer": "Customer",
    "customerFirst": "Choose the customer first: their sites are listed here.",
    "customerChange": {
      "title": "Change the customer?",
      "body_one": "The {{n}} chosen site is cleared: it belongs to the current customer.",
      "body_other": "The {{n}} chosen sites are cleared: they belong to the current customer.",
      "bodyAssets_one": "The {{n}} chosen site and {{assets}} are cleared: they belong to the current customer.",
      "bodyAssets_other": "The {{n}} chosen sites and {{assets}} are cleared: they belong to the current customer.",
      "assets_one": "{{n}} picked asset",
      "assets_other": "{{n}} picked assets",
      "confirm": "Change customer",
      "keep": "Keep the customer"
    },
    "title": "Title",
    "titleHint": "Optional; printed on the contract",
    "titlePlaceholder": "Al Noor Tower: AC maintenance",
    "start": "Starts",
    "end": "Ends",
    "startFixed": "An active contract keeps its start date.",
    "endLaterOnly": "An active contract's end only moves later.",
    "sites": "Sites",
    "sitesAll": "Choose all",
    "sitesNone": "Clear all",
    "siteAssets_one": "{{n}} asset",
    "siteAssets_other": "{{n}} assets",
    "siteUnder": "Under {{number}} to {{date}}",
    "sitesFailed": "Couldn't load the customer's sites.",
    "noSites": "This customer has no service sites yet.",
    "noSitesAdd": "Add the first one here; it is ticked for this contract.",
    "noSitesAsk": "Someone who manages service sites can add one on the customer's Service tab.",
    "addSite": "Add a site",
    "consumables": {
      "title": "Consumable categories",
      "body": "Products in these catalogue categories count as consumables on every maintenance contract (Settings › Contracts).",
      "label": "Categories",
      "save": "Save the categories",
      "keep": "Keep as they are",
      "saved": "Consumable categories saved ({{n}})"
    },
    "coverage": {
      "mode": "What the contract covers",
      "ALL": "Everything",
      "ALLBody": "Every asset at the chosen sites, now and as assets are added.",
      "TYPES": "Asset types",
      "TYPESBody": "The assets of chosen types at the sites (all their ACs, say).",
      "ASSETS": "Pick assets",
      "ASSETSBody": "A list of chosen assets; a replaced asset passes its place to the new one.",
      "types": "Asset types",
      "typesPlaceholder": "Choose the asset types it covers",
      "pickSitesFirst": "Choose the sites first: their assets are listed here.",
      "pickedHere": "{{picked}} of {{total}} picked",
      "place": "Place",
      "searchAssets": "Search tag, position or place…",
      "searchAssetsAt": "Search assets at {{site}}",
      "clearSearch": "Clear search",
      "selectAllHere": "Select all {{n}} here",
      "clearHere": "Clear this site",
      "selectFailed": "Couldn't select them all. Try again.",
      "assetsFailed": "Couldn't load the assets.",
      "assetsAt": "Assets at {{site}}",
      "noMatch": "No asset matches.",
      "noAssetsHere": "No assets here.",
      "cutOff": "Showing {{n}} of {{total}}: type more to narrow, or select them all.",
      "goneTitle_one": "{{n}} picked asset is no longer in service",
      "goneTitle_other": "{{n}} picked assets are no longer in service",
      "replacedBy": "Replaced by {{tag}}",
      "removed": "Removed",
      "pickSuccessor": "Pick {{tag}}",
      "successorPicked": "Its replacement is picked"
    },
    "terms": {
      "labour": {
        "INCLUDED": "Included",
        "INCLUDEDBody": "No labour charge on covered assets.",
        "EXCLUDED": "Billed",
        "EXCLUDEDBody": "Labour is charged on each job."
      },
      "parts": {
        "INCLUDED": "Included",
        "INCLUDEDBody": "Parts for covered assets cost nothing.",
        "EXCLUDED": "Billed",
        "EXCLUDEDBody": "Parts are charged on each job.",
        "CAPPED": "Up to a cap",
        "CAPPEDBody": "Covered up to an amount; past it the part is billed."
      },
      "consumables": {
        "INCLUDED": "Included",
        "INCLUDEDBody": "Filters, gas and cleaning chemicals (the categories in Settings › Contracts).",
        "EXCLUDED": "Billed",
        "EXCLUDEDBody": "Consumables are charged on each job."
      },
      "callOuts": {
        "INCLUDED": "Included",
        "INCLUDEDBody": "Visits for a fault are covered, up to a yearly number if you set one.",
        "EXCLUDED": "Billed",
        "EXCLUDEDBody": "Each call-out is charged; planned visits stay covered."
      },
      "cap": "Parts cap (before VAT)",
      "capBasis": "The cap is",
      "basis": {
        "PER_JOB": "per job",
        "PER_YEAR": "per contract year"
      },
      "perYear": "Call-outs a year",
      "perYearHint": "Leave empty for unlimited",
      "unlimited": "Unlimited",
      "response": "Response time (hours)",
      "responseHint": "Shown on each job; optional",
      "specialHint": "What the common terms don't say; printed on the contract.",
      "noConsumables": "No consumable categories are set in Settings › Contracts, so no item counts as a consumable yet.",
      "noConsumablesLink": "Choose the categories",
      "noConsumablesAsk": "An administrator can choose them in Settings › Contracts."
    },
    "plansBody": "Plans make the planned visits. Add them now or later on the contract's Plans tab.",
    "noPlans": "No plans yet.",
    "addPlan": "Add a plan",
    "removePlan": "Remove plan",
    "removePlanNamed": "Remove plan {{name}}",
    "planRow": "Plan {{n}}",
    "planRemoved": "Plan {{name}} removed",
    "undo": "Undo",
    "value": "Value (before VAT)",
    "valueHint": "For the whole period",
    "taxRate": "VAT",
    "taxDefault": "The company's default rate",
    "taxDefaultNamed": "Default: {{name}}",
    "schedule": "Billing schedule",
    "timing": "When each instalment is billed",
    "instalments": {
      "title_one": "{{n}} instalment",
      "title_other": "{{n}} instalments",
      "caption": "The instalments the schedule makes",
      "period": "Period",
      "billed": "Billed on",
      "amount": "Amount",
      "total": "Total (the value)",
      "custom": "A custom schedule: the instalments are entered on the contract once it is active.",
      "none": "Enter the value and the period to see the instalments.",
      "free": "No instalments: the contract is free of charge.",
      "failed": "Couldn't load the contract's instalments.",
      "existing_one": "{{n}} instalment on the contract",
      "existing_other": "{{n}} instalments on the contract",
      "existingCaption": "The contract's instalments",
      "valueOnly": "Saving changes the value only. Rebuild the un-invoiced instalments on the Billing tab.",
      "matches": "The instalments not yet invoiced already match this value and schedule.",
      "customOnly": "The schedule is custom: change the instalments by hand on the Billing tab.",
      "rebuildNone": "A rebuild would leave no instalment to invoice: the invoiced ones cover the value.",
      "rebuildWould_one": "A rebuild would make {{n}} instalment:",
      "rebuildWould_other": "A rebuild would make {{n}} instalments:"
    },
    "saveDraft": "Save draft",
    "save": "Save contract",
    "saveAndActivate": "Save and activate",
    "moreActions": "More actions",
    "errors": {
      "notSaved": "The contract wasn't saved",
      "fix": "Some fields need attention.",
      "customer": "Choose the customer.",
      "date": "Enter a date.",
      "endBeforeStart": "The end is before the start.",
      "sites": "Choose each site once.",
      "sitesToActivate": "Choose at least one site to activate the contract.",
      "types": "Choose the asset types it covers.",
      "assets": "Pick the assets it covers.",
      "partsCap": "Enter the parts cap.",
      "partsCapBasis": "Per job or per contract year?",
      "callOutsPerYear": "Enter a number from 1 to 365, or leave it empty for unlimited.",
      "responseHours": "Enter hours from 1 to 720, or leave it empty.",
      "value": "Enter the value: 0 or more."
    },
    "salesperson": "Salesperson",
    "salespersonHint": "Who sold the contract: its instalment invoices credit them.",
    "salespersonDefault": "The customer’s salesperson"
  },
  "summary": {
    "title": "What the customer gets",
    "who": "For",
    "when": "Period",
    "what": "Covered",
    "terms": "On these terms",
    "plans": "Planned visits",
    "price": "Price",
    "noCustomer": "Choose the customer.",
    "noSites": "no sites yet",
    "typesNone": "Choose the asset types",
    "covered_one": "{{n}} asset covered",
    "covered_other": "{{n}} assets covered",
    "coveredUnknown": "Counting the covered assets…",
    "noPlans": "No plans yet.",
    "noValue": "Enter the value.",
    "priceOnly": "{{value}} before VAT",
    "priceUpfront": "{{value}} before VAT, in one instalment, {{timing}}",
    "priceBilled_one": "{{value}} before VAT, in {{n}} instalment, {{schedule}} {{timing}}",
    "priceBilled_other": "{{value}} before VAT, in {{n}} instalments, {{schedule}} {{timing}}",
    "valueShort": "{{value}}"
  },
  "customerTab": {
    "title": "Contracts",
    "count_one": "{{n}} maintenance contract",
    "count_other": "{{n}} maintenance contracts",
    "showAll": "Show in the register",
    "empty": "No maintenance contracts.",
    "emptyBody": "Add a contract to cover this customer's sites."
  },
  "job": {
    "coverageTitle": "Maintenance contract",
    "coveredBy": "A maintenance contract covers this site",
    "coveredByMany": "Maintenance contracts cover this site",
    "billUnder": "How the job is billed",
    "underContract": "Under contract {{number}}",
    "chargeable": "Chargeable",
    "chargeableBody": "Bill this job as usual, outside the contract.",
    "coveredByNumber": "Covered by {{number}}",
    "billedAsUsual": "Billed as usual · {{number}} covers this site",
    "billInstead": "Bill instead",
    "useContract": "Use the contract",
    "overAllowanceNext": "This call-out passes the year's allowance: its labour will be chargeable.",
    "notCoveredAssets": "Not covered: {{assets}}",
    "notCoveredOthers_one": "{{n}} other asset",
    "notCoveredOthers_other": "{{n}} other assets",
    "blockTitle": "The job's maintenance contract",
    "under": "Under contract",
    "planned": "Planned visit · {{plan}} · {{period}}",
    "overAllowance": "Over the year's call-out allowance: labour on this job is chargeable.",
    "notCovered_one": "Not covered by the contract:",
    "notCovered_other": "Not covered by the contract:",
    "itemCovered": "Covered",
    "itemChargeable": "Chargeable"
  },
  "site": {
    "chip": "Under contract",
    "chipTitle": "{{number}}, to {{date}}"
  },
  "asset": {
    "title": "Contract coverage",
    "none": "Not covered by a maintenance contract.",
    "nextDue": "Next {{date}}"
  },
  "print": {
    "title": "Maintenance contract",
    "back": "Back to {{number}}",
    "draftNote": "A draft: it prints marked DRAFT until it is activated.",
    "billingFailed": "Couldn't load the contract's instalments, so it can't be printed yet.",
    "period": "Period",
    "activated": "Activated",
    "renews": "Renews",
    "customer": "Customer",
    "subject": "Subject",
    "sites": "Sites",
    "coverage": "Coverage",
    "terms": "Terms",
    "plans": "Planned maintenance",
    "plan": "Plan",
    "how": "How often",
    "checklist": "Checklist",
    "price": "Price and billing",
    "instalments": "Instalments",
    "plusTax": "plus VAT at {{rate}}%",
    "plusDefaultTax": "plus VAT",
    "signatures": "Signatures",
    "forCompany": "For the company",
    "forCustomer": "For the customer",
    "signName": "Name",
    "signSignature": "Signature",
    "signDate": "Date",
    "footer": "Covered assets are serviced as these terms say.",
    "footerMoney": "Amounts in Omani rials (<rial/>), before VAT."
  },
  "tasks": {
    "renewalTitle": "Renewal follow-up {{number}}",
    "followUpTitle": "Follow-up {{number}}"
  },
  "approval": {
    "needed": "Activating this contract sends it for approval first.",
    "neededWorkflow": "Workflow: {{name}}",
    "waiting": "Awaiting approval",
    "waitingStep": "Waiting for “{{step}}” · step {{index}} of {{total}}",
    "locked": "The contract can't change until the request is decided.",
    "onHoldBody": "The request is frozen: no one can approve, reject or withdraw it, and the contract stays a draft until approval workflows are turned back on.",
    "activating": "Approved; activating the contract…",
    "activateFailed": "Approved, but the contract wasn't activated.",
    "approved": "Approved",
    "stale": "The contract changed after it was approved. Activate it again.",
    "rejected": "Rejected",
    "returned": "Returned for changes",
    "editResend": "Change the contract if needed, then activate it again to send it for approval.",
    "withdrawn": "The approval request was withdrawn. Activate the contract again when it is ready.",
    "withdrawBody": "The approvers' tasks close and the contract can be edited again. Activating it sends it for approval again."
  },
  "approvalDetail": {
    "covers": "Covers:",
    "terms": "Terms:",
    "priceChange": "Price:",
    "priceChangeBody": "{{change}} on {{number}}: {{from}} → {{to}}"
  }
}
